<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  computed: {
    isError() {
      if (this.action?.variant === 'error') return true;
      return /(^|\b)(failed|error|unable|invalid|denied)\b/i.test(this.message);
    },
    snackbarClass() {
      // WLAB's tailwind theme.colors replaces the defaults — `rose` is
      // NOT in the palette so bg-rose-* compiles to nothing, leaving
      // error toasts white-on-white (the project_wlab_tailwind_palette
      // gotcha). `red` IS in the palette as a Radix-backed scale.
      return this.isError
        ? 'bg-red-600/95 border border-red-400/40'
        : 'bg-n-slate-12 dark:bg-n-slate-7';
    },
  },
};
</script>

<template>
  <div>
    <div
      class="shadow-sm rounded-lg items-center gap-3 inline-flex mb-2 max-w-[25rem] min-h-[1.875rem] min-w-[15rem] px-6 py-3 text-left"
      :class="snackbarClass"
    >
      <div class="text-sm font-medium text-white dark:text-white">
        {{ message }}
      </div>
      <div v-if="action">
        <router-link
          v-if="action.type == 'link'"
          :to="action.to"
          class="font-medium cursor-pointer select-none text-n-blue-10 hover:text-n-brand"
        >
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>
